import { palette, TipType, pxToRem } from "@ottatech/design";
import styled, { css } from "styled-components";

const Prompt = styled.div<{ level: TipType }>`
  position: relative;
  ${({ level }) => {
    switch (level) {
      case "warning":
        return css`
          background-color: ${palette.extended.red.shade500};
        `;
      case "positive":
        return css`
          background-color: ${palette.extended.green.shade200};
        `;
      default:
    }
  }}
  max-width: ${pxToRem(400)};
`;

export const DashboardPromptNotification = ({
  className,
  Component,
  level,
  onLoad,
  onButtonClick,
  onDismiss,
}: {
  className?: string;
  Component: React.ElementType;
  level: TipType;
  onLoad: (data: Record<string, unknown>) => void;
  onButtonClick: () => void;
  onDismiss: () => void;
}): React.ReactElement => {
  return (
    <Prompt className={className} level={level}>
      <Component
        onLoad={onLoad}
        onButtonClick={onButtonClick}
        onDismiss={onDismiss}
      />
    </Prompt>
  );
};
